const resource = '/v1/document-types';

export default $axios => ({
  index() {
    return $axios.get(`${resource}`);
  }
});
